import moment from "moment"
import {
  SET_IR_LOADING,
  SET_IR_FORMS,
  SET_TOTAL_IR_FORMS,
  SET_TOTAL_IR_PAGES,
  SET_IR_PRODUCTS,
  SET_IR_DATE,
  SET_IR_SUPPLIER,
  SET_IR_ETA,
  SET_IR_INTERNATIONAL,
  CLEAR_NEW_IR,
} from "../actions/internalRequisition"

const initialState = {
  isLoading: false,
  irForms: [],
  totalIrForms: 0,
  totalPages: 0,
  newIr: {
    id: "",
    irProducts: [],
    date: moment().format("YYYY-MM-DD"),
    supplier: "",
    eta: moment().format("YYYY-MM-DD"),
    international: false,
    senderAddress: "184, Buthgamuwa Road",
    senderCity: "Rajagiriya, Sri Lanka",
    senderTel: "0112 805 005 / 0761 399 060 / 0761 399 063",
    sendersEmail: "info@gundapower.com / www.gundapower.com",
  },
}

const InternalRequisitionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IR_LOADING:
      return {
        ...state,
        isLoading: action.data,
      }

    case SET_IR_FORMS:
      return {
        ...state,
        irForms: action.data,
      }

    case SET_TOTAL_IR_FORMS:
      return {
        ...state,
        totalIrForms: action.data,
      }

    case SET_TOTAL_IR_PAGES:
      return {
        ...state,
        totalPages: action.data,
      }

    case SET_IR_PRODUCTS:
      return {
        ...state,
        newIr: { ...state.newIr, irProducts: action.data },
      }

    case SET_IR_DATE:
      return {
        ...state,
        newIr: { ...state.newIr, date: action.data },
      }

    case SET_IR_SUPPLIER:
      return {
        ...state,
        newIr: { ...state.newIr, supplier: action.data },
      }

    case SET_IR_ETA:
      return {
        ...state,
        newIr: { ...state.newIr, eta: action.data },
      }

    case SET_IR_INTERNATIONAL:
      return {
        ...state,
        newIr: { ...state.newIr, international: action.data },
      }

    case CLEAR_NEW_IR:
      return {
        ...state,
        newIr: {
          id: "",
          irProducts: [],
          date: moment().format("YYYY-MM-DD"),
          supplier: "",
          eta: moment().format("YYYY-MM-DD"),
          international: false,
        },
      }

    default:
      return state
  }
}

export default InternalRequisitionReducer
